<template>
    <div id="page-user-list">
      <div class="vx-card p-6">
        <div class="flex flex-wrap items-center">
          <!-- ITEMS PER PAGE -->
          <vs-popup classContent="popup-example" title="Manage Banner" :active.sync="popup">
            <template>
              <div class="vx-row">
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input class="w-full" label="Name" v-model="userSelect.name" />
                  </div>
                  <div class="vx-col sm:w-1/2 w-full mb-2">
                      <vs-input class="w-full" label="Order" v-model="userSelect.order" />
                  </div>
              </div>
              <div class="vx-row">
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                    รูปภาพ <input type="file" class="w-full" ref="input1" label="รูปภาพ" @change="previewImage" accept="image/*"/>
                  </div>
              </div>
              <div class="vx-row" v-if="img1 || userSelect.image">
                  <div class="vx-col sm:w-2/2 w-full mb-2">
                    <img class="preview" height="150" width="300" :src="(img1)?img1:userSelect.image">
                  </div>
              </div>
            </template>
            <br>
            <vs-button color="primary" type="filled" @click="updateUser">Save</vs-button>&nbsp;&nbsp;&nbsp;
            <vs-button color="dark" type="filled" @click="closePopup">Close</vs-button>
          </vs-popup>
          <div class="flex-grow">
            <vs-dropdown vs-trigger-click class="cursor-pointer">
              <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                <span class="mr-2">{{ currentPage * paginationPageSize - (paginationPageSize - 1) }} - {{ usersData.length - currentPage * paginationPageSize > 0 ? currentPage * paginationPageSize : usersData.length }} of {{ usersData.length }}</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
              <!-- <vs-button class="btn-drop" type="line" color="primary" icon-pack="feather" icon="icon-chevron-down"></vs-button> -->
              <vs-dropdown-menu>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(10)">
                  <span>10</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(20)">
                  <span>20</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(25)">
                  <span>25</span>
                </vs-dropdown-item>
                <vs-dropdown-item @click="gridApi.paginationSetPageSize(30)">
                  <span>30</span>
                </vs-dropdown-item>
              </vs-dropdown-menu>
            </vs-dropdown>
          </div>
  
          <!-- TABLE ACTION COL-2: SEARCH & EXPORT AS CSV -->
            <vs-input class="sm:mr-4 mr-0 sm:w-auto w-full sm:order-normal order-3 sm:mt-0 mt-4" v-model="searchQuery" @input="updateSearchQuery" placeholder="Search..." />
            <!-- <vs-button class="mb-4 md:mb-0" @click="gridApi.exportDataAsCsv()">Export as CSV</vs-button> -->
            <vs-button type="filled" @click="addUser()" icon-pack="feather" icon="icon-plus">ADD BANNER</vs-button>
            <!-- ACTION - DROPDOWN -->
            <!--vs-dropdown vs-trigger-click class="cursor-pointer">
  
              <div class="p-3 shadow-drop rounded-lg d-theme-dark-light-bg cursor-pointer flex items-end justify-center text-lg font-medium w-32">
                <span class="mr-2 leading-none">Actions</span>
                <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
              </div>
  
              <vs-dropdown-menu>
                <vs-dropdown-item @click="Add()">
                  <span class="flex items-center">
                    <feather-icon icon="UserPlusIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Add</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item @click="Delete()">
                  <span class="flex items-center">
                    <feather-icon icon="TrashIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Delete</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon icon="ArchiveIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Archive</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>Print</span>
                  </span>
                </vs-dropdown-item>
  
                <vs-dropdown-item>
                  <span class="flex items-center">
                    <feather-icon icon="SaveIcon" svgClasses="h-4 w-4" class="mr-2" />
                    <span>CSV</span>
                  </span>
                </vs-dropdown-item>>
  
              </vs-dropdown-menu>
            </!--vs-dropdown-->
        </div>
  
  
        <!-- AgGrid Table floatingFilter="true"-->
        <!--:onGridReady="onGridReady" -->
        <ag-grid-vue
          ref="agGridTable"
          :components="components"
          :gridOptions="gridOptions"
          class="ag-theme-material w-100 my-4 ag-grid-table"
          :columnDefs="columnDefs"
          :defaultColDef="defaultColDef"
          :rowData="usersData"
          rowSelection="multiple"
          colResizeDefault="shift"
          :animateRows="true"
          :pagination="true"
          :paginationPageSize="paginationPageSize"
          :suppressPaginationPanel="true"
          :enableRtl="$vs.rtl"
          >
        </ag-grid-vue>
        <vs-pagination
          :total="totalPages"
          :max="7"
          v-model="currentPage" />
  
      </div>
    </div>
  
  </template>
  
  <script>
  import { AgGridVue } from 'ag-grid-vue'
  import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
  import vSelect from 'vue-select'
  // Store Module
  // Cell Renderer
  
  import CellRendererImage from './cell-renderer/CellRendererImage.vue'
  import CellRendererLink from './cell-renderer/CellRendererLink.vue'
  import CellRendererStatus from './cell-renderer/CellRendererStatus.vue'
  import CellRendererVerified from './cell-renderer/CellRendererVerified.vue'
  import CellRendererActions from './cell-renderer/CellRendererActions.vue'
  import CellRendererCreateDate from './cell-renderer/CellRendererCreateDate.vue'
  import CellRendererBank from './cell-renderer/CellRendererBank.vue'
  import moment from "moment-timezone";
  import firebase from 'firebase/app'
  import 'firebase/database'
  import 'firebase/firestore'
  import 'firebase/storage'
  import { createHelpers } from 'vuex-map-fields'
  const { mapFields } = createHelpers({
    getterType: `userManagement/getField`,
    mutationType: `userManagement/updateField`,
  });
  export default {
    components: {
      AgGridVue,
      vSelect,
      // Cell Renderer
      CellRendererLink,
      CellRendererStatus,
      CellRendererVerified,
      CellRendererActions,
      CellRendererCreateDate,
      CellRendererImage,
      CellRendererBank
    },
    data () {
      return {
        img1: '',
        imageData: null,
        user:{
          username:'',
          password:'',
          detail:''
        },
        userId:'',
        selected: '',
        selectedmenu: '',
        adminsend:'',
        // Filter Options
        roleFilter: { label: 'All', value: 'all' },
        roleOptions: [
          { label: 'All', value: 'all' },
          { label: 'Admin', value: 'admin' },
          { label: 'User', value: 'user' },
          { label: 'Staff', value: 'staff' }
        ],
  
        statusFilter: { label: 'All', value: 'all' },
        statusOptions: [
          { label: 'All', value: 'all' },
          { label: 'Active', value: 'active' },
          { label: 'Deactivated', value: 'deactivated' },
          { label: 'Blocked', value: 'blocked' }
        ],
  
        isVerifiedFilter: { label: 'All', value: 'all' },
        isVerifiedOptions: [
          { label: 'All', value: 'all' },
          { label: 'Yes', value: 'yes' },
          { label: 'No', value: 'no' }
        ],
  
        departmentFilter: { label: 'All', value: 'all' },
        departmentOptions: [
          { label: 'All', value: 'all' },
          { label: 'Sales', value: 'sales' },
          { label: 'Development', value: 'development' },
          { label: 'Management', value: 'management' }
        ],
  
        searchQuery: '',
  
        // AgGrid
        gridApi: null,
        gridOptions: {
          rowHeight: 100,
          suppressContextMenu:true,
        //   onCellEditingStopped: (event) => {
        //     if(event.column.colId === 'status'){
        //       this.$store.dispatch('userManagement/updateFieldRewards',{key:event.data.key,value:event.value,column:event.column.colId}).catch(err => { console.error(err) })
        //     }
        //   }
        },
        defaultColDef: {
          sortable: true,
          editable: true,
          resizable: true,
          suppressMenu: true
        },
        columnDefs: [
          {
            headerName: 'Name',
            field: 'name',
            width: 200,
            filter: true,
          },
          {
            headerName: 'รูปภาพ',
            field: 'image',
            width: 100,
            cellRendererFramework: 'CellRendererImage'
          },
          {
            headerName: 'Order',
            field: 'order',
            width: 100,
            filter: true,
          },
          {
            headerName: 'Create Date',
            field: 'createdate',
            filter: true,
            width: 200,
            cellRendererFramework: 'CellRendererCreateDate'
          },
          {
            headerName: 'Status',
            field: 'status',
            filter: true,
            width: 100,
            cellRendererFramework: 'CellRendererStatus'
          },
          {
            headerName: 'Actions',
            field: 'transactions',
            width: 150,
            cellRendererFramework: 'CellRendererActions'
          }
        ],
  
        // Cell Renderer Components
        components: {
          CellRendererImage,
          CellRendererCreateDate,
          CellRendererBank,
          CellRendererLink,
          CellRendererStatus,
          CellRendererVerified,
          CellRendererActions
        }
      }
    },
    watch: {
      roleFilter (obj) {
        this.setColumnFilter('role', obj.value)
      },
      statusFilter (obj) {
        this.setColumnFilter('status', obj.value)
      },
      departmentFilter (obj) {
        this.setColumnFilter('department', obj.value)
      }
    },
    computed: {
      ...mapFields([
          'popup',
          'popup2',
      ]),
      userLogin(){
        return this.$store.state.AppActiveUser
      },
      userOption(){
        return this.$store.state.userManagement.userOption
      },
      usersData () {
        return this.$store.state.userManagement.banners
      },
      userSelect () {
        return this.$store.state.userManagement.banner_select
      },
      paginationPageSize () {
        //if (this.gridApi) return this.gridApi.paginationGetPageSize() else
        return 100
      },
      totalPages () {
        if (this.gridApi) return this.gridApi.paginationGetTotalPages()
        else return 0
      },
      currentPage: {
        get () {
          if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
          else return 1
        },
        set (val) {
          this.gridApi.paginationGoToPage(val - 1)
        }
      }
    },
    methods: {
      previewImage(event) {
        this.imageData = event.target.files[0];
        this.img1 = URL.createObjectURL(this.imageData);
        //this.onUpload()
      },
      onGridReady(params){
          this.gridApi = params.api;
          this.columnApi = params.columnApi;
          this.gridApi.sizeColumnsToFit();
          window.onresize = () => {
              this.gridApi.sizeColumnsToFit();
          }
      },
      // confirmDeleteRecord (data) {
      //   this.$vs.dialog({
      //     type: 'confirm',
      //     color: 'danger',
      //     title: 'Confirm Delete',
      //     text: `You are about to delete "${data}"`,
      //     accept: this.deleteRecord,
      //     acceptText: 'Delete'
      //   })
      // },
      // async deleteRecord () {
      //   for(const data of this.gridApi.getSelectedRows()){
      //     const emailKey = data.email.trim().replace(/\./g, '||');
      //     await firebase.database().ref().child(`users/${emailKey}`).remove();
      //   }
      //   this.showDeleteSuccess()
      //   this.$store.dispatch('userManagement/fetchRewards').catch(err => { console.error(err) })
      // },
      // showDeleteSuccess () {
      //   this.$vs.notify({
      //     color: 'success',
      //     title: 'User Deleted',
      //     text: 'The selected user was successfully deleted'
      //   })
      // },
      // Delete(){
      //   if(this.gridApi.getSelectedRows().length){
      //     let text = ''
      //     for(const data of this.gridApi.getSelectedRows()){
      //       text += (text)?', '+data.firstname:data.firstname
      //     }
      //     this.confirmDeleteRecord(text);
      //   }
      // },
      setColumnFilter (column, val) {
        const filter = this.gridApi.getFilterInstance(column)
        let modelObj = null
  
        if (val !== 'all') {
          modelObj = { type: 'equals', filter: val }
        }
  
        filter.setModel(modelObj)
        this.gridApi.onFilterChanged()
      },
      resetColFilters () {
        // Reset Grid Filter
        this.gridApi.setFilterModel(null)
        this.gridApi.onFilterChanged()
  
        // Reset Filter Options
        this.roleFilter = this.statusFilter = this.isVerifiedFilter = this.departmentFilter = { label: 'All', value: 'all' }
  
        this.$refs.filterCard.removeRefreshAnimation()
      },
      updateSearchQuery (val) {
        this.gridApi.setQuickFilter(val)
      },
      async updateUser(){
        if(this.userSelect.key){
            firebase.database().ref('banners/3/'+this.userSelect.key).update({
              name:this.userSelect.name,
              order:Number(this.userSelect.order),
              updatedate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
              status:'Y',
              user_updated:this.userLogin.email,
              userUpdated:this.userLogin,
            }).then(()=>{
              this.saveImage(this.userSelect.key);
              this.closePopup();
              this.$store.commit('userManagement/SET_BANNERSELECTED', {
                name:'',
                order:'',
                createdate:'',
                key:'',
              });
            }).then(()=>{
              setTimeout(() => {
                this.$store.dispatch('userManagement/fetchBanners3').catch(err => { console.error(err) })
              }, 2000);
            });
        }else{
            firebase.database().ref('banners/3').push({
              name:this.userSelect.name,
              order:Number(this.userSelect.order),
              createdate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
              updatedate:moment().tz("Asia/Bangkok").format("YYYY-MM-DD HH:mm:ss"),
              status:'Y',
              user_created:this.userLogin.email,
              userCreated:this.userLogin,
              user_updated:this.userLogin.email,
              userUpdated:this.userLogin,
            }).then(async (result)=>{
              await this.saveImage(result.key);
              this.closePopup();
              this.$store.commit('userManagement/SET_BANNERSELECTED', {
                name:'',
                order:'',
                createdate:'',
                key:'',
              });
            }).then(()=>{
              setTimeout(() => {
                this.$store.dispatch('userManagement/fetchBanners3').catch(err => { console.error(err) })
              }, 2000);
            });
        }
      },
      async saveImage(id){
        if(this.img1 !== ''){
          const imagetype = this.imageData.name.split('.');
          const storageRef = firebase.storage().ref(`images/${id}.${imagetype[imagetype.length-1]}`).put(this.imageData);
          await storageRef.on(`state_changed`,snapshot=>{
              this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
            }, error=>{console.log(error.message)},
          ()=>{
              storageRef.snapshot.ref.getDownloadURL().then((url)=>{
                  firebase.database().ref('banners/3/'+id).update({
                    image:url,
                  })
              });
              this.img1 = '';
          });
        }
      },
      addUser(){
        this.$store.commit('userManagement/SET_POPUP', true);
      },
      closePopup(){
         this.$store.commit('userManagement/SET_POPUP', false);
         this.$store.commit('userManagement/SET_POPUP2', false);
      },
    },
    mounted () {
      // const room = 'C002';
      // const order = 22;
      // const percent = 50;
      // const image = `r_allbet_${room}.png`;
      // firebase.database().ref('casino/allbet/'+room).update({
      //   room,
      //   order,
      //   percent,
      //   image
      // });
      this.gridApi = this.gridOptions.api
      if(window.innerWidth>1000)
      setTimeout( ()=> this.gridApi.sizeColumnsToFit(), 0 );
      /* =================================================================
        NOTE:
        Header is not aligned properly in RTL version of agGrid table.
        However, we given fix to this issue. If you want more robust solution please contact them at gitHub
      ================================================================= */
      
      if (this.$vs.rtl) {
        const header = this.$refs.agGridTable.$el.querySelector('.ag-header-container')
        header.style.left = `-${  String(Number(header.style.transform.slice(11, -3)) + 9)  }px`
      }
    },
    created () {
      this.$store.dispatch('userManagement/fetchBanners3').catch(err => { console.error(err) })
    }
  }
  
  </script>
  
  <style lang="scss">
  #page-user-list {
    .user-list-filters {
      .vs__actions {
        position: absolute;
        right: 0;
        top: 50%;
        transform: translateY(-58%);
      }
    }
  }
  </style>
  